registerComponent("templates/cookiebar", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ ESTA BARRA NÃO PINTA EM PÁGINA NENHUMA, e não é consequência da
 * transposição: o `display: none` da raiz, em `_cookiebar.less`, está
 * descomentado desde 12/07/2023 (commit `7331f5e8` — antes dele a linha era
 * `// display: none`). O sub-lote 5b preserva o estado tal como está; religar
 * ou apagar a barra é decisão do responsável, registrada no relatório.
 *
 * O que era `TweenLite.from/to(y: '110%')` virou a classe `.is-fora` com
 * `transition: transform` no LESS. Não há `transitionend` porque não há nada
 * para fazer no fim: os dois tweens de 2020 também não tinham `onComplete`, e
 * o que escondia a barra era o `.hide()` do cookie já aceito, que roda antes
 * de qualquer transição.
 *
 * `getCookie`, `createCookie` e `keepConnect` são cópia literal de 2020: o
 * nome `cookieOptin` e o prazo de 6 meses são contrato com quem respondeu ao
 * consentimento, não detalhe de implementação. O cookiebar do design
 * (`templates/cookiebar-redesign`) lê o mesmo `cookieOptin` como "aceitou
 * tudo" enquanto os dois coexistirem.
 */

const btnOK = component.querySelector('.btn-ok');

if (getCookie('cookieOptin')) {
    component.style.display = 'none';
} else {
    entrar();
}

if (btnOK) {
    btnOK.addEventListener('click', function () {
        createCookie({ cookieOptin: 1 }, keepConnect());

        component.classList.add('is-fora');
    });
}

/**
 * A entrada de baixo para cima. Pinta o estado "fora da tela" e o tira no
 * quadro seguinte — dois `requestAnimationFrame` para que o "antes" chegue a
 * ser pintado, senão o navegador colapsa os dois estados e não há transição.
 * O `setTimeout` é a rede de segurança de aba em segundo plano, onde
 * `requestAnimationFrame` não dispara; o mesmo padrão de `Asa.revelar`.
 */
function entrar() {
    component.classList.add('is-fora');

    const subir = () => component.classList.remove('is-fora');

    requestAnimationFrame(() => requestAnimationFrame(subir));
    setTimeout(subir, Asa.ESPERA_MAXIMA);
}

function keepConnect() {
    let expire = new Date();
    let limit = expire.getMonth() + 6;

    if (limit > 11) {
        expire.setMonth(limit - 12);
        expire.setFullYear(expire.getFullYear() + 1);
    } else {
        expire.setMonth(limit);
    }

    return expire;
}

function createCookie(data, limit) {
    for (let item in data) {
        document.cookie = `${item}=${data[item]}; expires=${limit}; path=/`;
    }
}

function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
}

});
